import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import {
  DataProtectionNoticeItemFileState,
  DataProtectionNoticeItemFileStateModel,
} from './data-protection-notice-item-file.state';
import {
  DataProtectionNoticeItemFileDownload,
  DataProtectionNoticeItemFileInitialState,
  DataProtectionNoticeItemFileLoad,
  DataProtectionNoticeLastItemFileLoad,
} from './data-protection-notice-item-file.actions';

@Injectable({ providedIn: 'root' })
export class DataProtectionNoticeItemFileFacade {
  dpnItemFileData$: Observable<DataProtectionNoticeItemFileStateModel> = this.store.select(
    DataProtectionNoticeItemFileState.getState,
  );
  loaded$: Observable<boolean> = this.store.select(DataProtectionNoticeItemFileState.getLoaded);

  constructor(private store: Store) {}

  getDpnFileItem(dpnFileId: string): void {
    this.store.dispatch(new DataProtectionNoticeItemFileLoad(dpnFileId));
  }

  downloadDpnFile(dpnFileId: string, version: string): void {
    this.store.dispatch(new DataProtectionNoticeItemFileDownload({ dpnFileId, version }));
  }

  getLastDpnItemFile(country: string): void {
    this.store.dispatch(new DataProtectionNoticeLastItemFileLoad(country));
  }

  setInitialState(): void {
    this.store.dispatch(new DataProtectionNoticeItemFileInitialState());
  }
}
